import { render } from "./TicketClient.vue?vue&type=template&id=945a01e0"
import script from "./TicketClient.vue?vue&type=script&lang=js"
export * from "./TicketClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__